export const emailRegex = /^[\w.%+\-]+@[\w.\-]+\.[a-z]{2,}$/iv;
